var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack395({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.5,
    y: 1.5,
    width: 13,
    height: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.51,11.16V5.57H5.09A2.84,2.84,0,0,1,6,5.68a1.5,1.5,0,0,1,.69.48,2.55,2.55,0,0,1,.46.9A4.34,4.34,0,0,1,7.3,8.33,4.22,4.22,0,0,1,7,9.94a2,2,0,0,1-.72.94,2,2,0,0,1-1.14.28Zm.61-.66h1a1.83,1.83,0,0,0,.9-.19,1.25,1.25,0,0,0,.46-.62,3.69,3.69,0,0,0,.22-1.36A3.26,3.26,0,0,0,6.44,7a1.27,1.27,0,0,0-.59-.65,2.05,2.05,0,0,0-.77-.11h-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.12,11.16V5.57H9l1.09,4,.22.82c.05-.2.13-.5.24-.89l1.1-3.89h.82v5.59h-.59V6.49l-1.33,4.67H10L8.71,6.41v4.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack395);
export default __webpack_public_path__ + "static/media/Symbol_pack_395.9c19fb56b2182b5a75fe9b6393af88b0.svg";
export { ForwardRef as ReactComponent };